<template>
    <div class="activity">
        <h2 class="activity__title">Mine registreringer</h2>
        <div v-if="registrations && registrations.length > 0">
            <p class="activity__intro">Denne listen gir en oversikt over alle dine registreringer i {{ selectedYear }}.
                Er en registrering feil, kan du slette den og eventuelt 
                legge den inn på nytt ved hjelp av registreringsskjemaet over .</p>
            <table class="activity__table" >
                <thead>
                    <tr>
                        <th>Dato:</th>
                        <th>{{ groupName }}:</th>
                        <th>Mengde:</th>
                        <th>Kommune:</th>
                        <th>Fjern</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="registration of registrations" :key="registration.id">
                        <td><span class="activity__label">Dato:</span>{{ formatDate(registration.date) }}</td>
                        <td>
                            <span class="activity__label">{{ groupName }}:</span>
                            <img v-if="registration.illustration_src" :src="registration.illustration_src" :alt="registration.illustration_alt" class="activity__type-icon">
                            {{ registration.type_name }}
                        </td>
                        <td><span class="activity__label">Mengde:</span>{{ registration.amount }} {{ registration.uom.name }}</td>
                        <td><span class="activity__label">Kommune:</span>{{ registration.location_name }}</td>
                        <td class="activity__remove" style="cursor: pointer" @click="$emit('delete', registration.id)"><span class="activity__label">Fjern</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p class="activity__empty" v-else>Ingen registreringer funnet for {{ selectedYear }}.</p>
    </div>
</template>
<script>
export default {
    props:{
        registrations : {
            type : Object,
            default : []
        },
        getUserAmount : {
            type: Number
        }, 
        groupName : {
            type: String
        },
        getAmountClass : {
            type: String
        },
        selectedYear : {
            type: Number
        }
    },
    emits: ['delete'],
    methods: {
        formatDate(date) {
            const options = {
                day  : '2-digit', 
                month: '2-digit', 
                year : '2-digit'
            };

            return (new Date(date)).toLocaleDateString("nb-NO", options);
        },
        amountImageUrl() {
            return '/img/amount_picked_L.svg';
        }
    }
}
</script>
